import { jsx, jsxs } from "react/jsx-runtime";
import { styled } from "@linaria/react";
import * as React from "react";
import { forwardRef } from "react";
import { typographyClassName } from "@creditornot/cb-ingredients";
import "./style.css";
const Checkmark = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M23.2665 2.33434C24.0619 2.90197 24.2377 3.99484 23.6593 4.77533L11.8707 21.2804C11.582 21.6699 11.1422 21.9252 10.6552 21.986C10.1683 22.0468 9.67734 21.9077 9.29841 21.6015L0.648785 14.6117C-0.110418 13.9982 -0.219027 12.897 0.406198 12.152C1.03142 11.407 2.15372 11.3004 2.91293 11.914L10.1027 17.7239L20.7789 2.71976C21.3573 1.93927 22.4711 1.76671 23.2665 2.33434Z" }) }));
function mergeRefs(refs) {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
}
const Root$1 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_InputCheckbox_Root_r1hm",
  propsAsIs: false
});
const BG = /* @__PURE__ */ styled("div")({
  name: "BG",
  class: "cb_InputCheckbox_BG_b1xt",
  propsAsIs: false
});
const _exp9 = () => Checkmark;
const CheckmarkIcon = /* @__PURE__ */ styled(_exp9())({
  name: "CheckmarkIcon",
  class: "cb_InputCheckbox_CheckmarkIcon_case",
  propsAsIs: true
});
const PartialCheckIcon = /* @__PURE__ */ styled("div")({
  name: "PartialCheckIcon",
  class: "cb_InputCheckbox_PartialCheckIcon_pkxt",
  propsAsIs: false
});
const IconContainer = /* @__PURE__ */ styled("div")({
  name: "IconContainer",
  class: "cb_InputCheckbox_IconContainer_i1xr",
  propsAsIs: false
});
const Input = /* @__PURE__ */ styled("input")({
  name: "Input",
  class: "cb_InputCheckbox_Input_ifis",
  propsAsIs: false
});
const InputCheckbox = ({
  checked,
  className,
  disabled,
  disableFocusAndActiveStyles = false,
  inputClassName,
  inputStyle,
  partiallyChecked = false,
  style,
  ...rest
}, ref) => /* @__PURE__ */ jsxs(Root$1, {
  className,
  style,
  children: [/* @__PURE__ */ jsx(Input, {
    "aria-checked": partiallyChecked ? "mixed" : checked,
    "data-fs": disableFocusAndActiveStyles ? void 0 : "",
    ...rest,
    checked,
    className: inputClassName,
    disabled,
    ref: mergeRefs([ref, (node) => {
      if (node) {
        node.indeterminate = partiallyChecked && !checked;
      }
    }]),
    style: inputStyle,
    type: "checkbox"
  }), /* @__PURE__ */ jsx(BG, {}), /* @__PURE__ */ jsx(IconContainer, {
    "data-checked": true,
    children: /* @__PURE__ */ jsx(CheckmarkIcon, {})
  }), /* @__PURE__ */ jsx(IconContainer, {
    "data-indeterminate": true,
    children: /* @__PURE__ */ jsx(PartialCheckIcon, {})
  })]
});
const InputCheckbox$1 = forwardRef(InputCheckbox);
const Root = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_Checkbox_Root_r1bk",
  propsAsIs: false
});
const TextLabel = /* @__PURE__ */ styled("span")({
  name: "TextLabel",
  class: "cb_Checkbox_TextLabel_tiqi",
  propsAsIs: false
});
const Label = /* @__PURE__ */ styled("label")({
  name: "Label",
  class: "cb_Checkbox_Label_l3nf",
  propsAsIs: false
});
const Content = /* @__PURE__ */ styled("span")({
  name: "Content",
  class: "cb_Checkbox_Content_c1j0",
  propsAsIs: false
});
const Checkbox = React.forwardRef(({
  checked,
  children,
  className,
  disabled,
  id,
  inputProps,
  name,
  onBlur,
  onChange,
  onClick,
  onFocus,
  partiallyChecked,
  readOnly,
  required,
  rootRef,
  style,
  value
}, ref) => /* @__PURE__ */ jsx(Root, {
  className,
  ref: rootRef,
  style,
  children: /* @__PURE__ */ jsxs(Label, {
    "aria-disabled": disabled ? true : void 0,
    htmlFor: id,
    children: [/* @__PURE__ */ jsx(InputCheckbox$1, {
      ...inputProps,
      checked,
      disabled,
      id,
      name,
      onBlur,
      onChange,
      onClick,
      onFocus,
      partiallyChecked,
      readOnly,
      ref,
      required,
      value
    }), children !== void 0 && /* @__PURE__ */ jsx(Content, {
      children: typeof children === "string" ? /* @__PURE__ */ jsx(TextLabel, {
        className: typographyClassName.Body3,
        children
      }) : children
    })]
  })
}));
Checkbox.displayName = "Checkbox";
export {
  Checkbox,
  InputCheckbox$1 as InputCheckbox
};
//# sourceMappingURL=index.js.map
